import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface StageParam {
    fileId: number;
    payload: { type: 'scroll-to'; page: number; focusBox?: number[] }
    | { type: 'fit-width'; page: number }
}

interface Queue {
    events: StageParam[];
}

const initialState: Queue = {
    events: []
}

const eventQueueSlice = createSlice({
    name: 'eventQueue',
    initialState,
    reducers: {
        enqueue: (state, action: PayloadAction<StageParam>) => {
            state.events.push(action.payload);
        },
        dequeue: (state) => {
            state.events.shift();
        }
    }
})

export const { enqueue, dequeue } = eventQueueSlice.actions;
export default eventQueueSlice.reducer;